import Vue from 'vue'
import router from './router/'
import store from './store/'
import './registerServiceWorker'
import './plugins/vuetify'
import './plugins/numeric'
import './plugins/validate'
import './plugins/acl/index'
import './plugins/config'
import './plugins/socket'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import 'font-awesome/css/font-awesome.css'
import './assets/theme/default.styl'
import './assets/theme/overwrite.css'

import App from './App.vue'

Vue.config.productionTip = false

const app = new Vue({
  router,
  store,
  render: h => h(App),
})

app.$mount('#app')
